import React, { useContext } from 'react';
import { Header as SharedHeader } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

import { MarketContext } from 'providers/market';
import { MastheadHeader } from 'utils/masthead/masthead';
import { useVerticalContext } from 'providers/vertical';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';

interface Props {
  data?: MastheadHeader;
}

interface ContainerProps {
  transparent: boolean;
}

const PLAIN_DATA = {
  navigation: {
    brand: {
      href: '#',
      alt: 'Spotify',
    },
  },
};

const Container = styled.div<ContainerProps>`
  a[href='#'] {
    cursor: default;
  }

  header {
    ${props => props.transparent && 'background: transparent !important;'}
  }
`;

const Gradient = styled.div`
  position: absolute;
  width: 100%;
  height: 200px;
  z-index: -1;
  background: linear-gradient(98.85deg, rgba(18, 18, 18, 0.3) 0%, var(--background-base) 100%),
    linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, var(--background-base) 100%), var(--text-bright-accent);
`;

export const Header = ({ data = PLAIN_DATA }: Props) => {
  const { preferredDir } = useContext(MarketContext);
  const { features } = useVerticalContext();

  const { showHeaderGradient } = features;

  return (
    <Container dir={preferredDir} transparent={showHeaderGradient}>
      {showHeaderGradient && <Gradient aria-hidden="true" />}
      {features.configureNavigation ? (
        <NavigationHeader config={features.configureNavigation} />
      ) : (
        <SharedHeader {...data} fixed={false} transparent={showHeaderGradient} />
      )}
    </Container>
  );
};
